import { useQuery } from 'react-query';
import { getGatheringTemplates } from '~/api/gatherings';

export const useGatheringTemplates = (buildingId: string) =>
  useQuery(['gathering-templates', buildingId], () =>
    getGatheringTemplates(buildingId)
  );
